/* eslint-disable react/no-danger */

// 'use client';

import React from 'react';

import { mergeClasses } from '@utils';

export default function TinyBanner({ tinyBanner }) {
  if (!tinyBanner || !Array.isArray(tinyBanner) || tinyBanner?.length === 0)
    return null;

  return (
    <div
      className={mergeClasses(
        'relative flex h-10 w-full items-center overflow-hidden px-4 text-center text-sm text-black lg:justify-center',
        {
          'bg-gradient-to-r from-[#47E9FF] to-[#0CD428]': !tinyBanner[0]?.color
        }
      )}
      style={{
        backgroundColor: tinyBanner[0]?.color
      }}
    >
      <div
        className="inline-block shrink-0 break-all text-left"
        dangerouslySetInnerHTML={{ __html: tinyBanner[0]?.html }}
      />
      <a
        href={tinyBanner[0]?.button_link}
        className="ml-2 shrink-0 text-sm underline"
        style={{
          color: tinyBanner[0]?.button_color || 'black'
        }}
      >
        {tinyBanner[0]?.button_text}
      </a>
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-gradient-to-r from-white/30 via-transparent to-white/30" />
    </div>
  );
}
